export enum EIdentityDocumentType {
  NONE = 'NONE',
  PASSPORT = 'PASSPORT',
  GOVERNMENT_ID = 'GOVERNMENT_ID',
  ELECTRONIC_GOVERNMENT_ID = 'ELECTRONIC_GOVERNMENT_ID',
}
